import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import TextField from 'apollo-react/components/TextField';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { REPORT_MODEL_DESIGNER } from '../constants/Urls';
import { useTranslation } from '../custom-hooks/useTranslation';
import {
  initialErrors,
  initialReportSettings,
} from '../report-model-designer/constants/new-report-model.constants';
import {
  validateNewReportModalOnBlur,
  validateNewReportModalOnCreate,
} from '../report-model-designer/utils/validation-report-model.utils';

const useStyles = makeStyles({
  modal: {
    width: 650,
  },
});

const NewReportModelDialog = ({ open, handleClose }) => {
  const classes = useStyles();
  const translateString = useTranslation();
  const history = useHistory();

  const [reportSettings, setReportSettings] = useState(initialReportSettings);
  const [modalErrors, setErrors] = useState(initialErrors);

  const hasModalErrors = Object.values(modalErrors).filter((item) => item.hasError).length !== 0;

  const handleReportSettingsChange = (e) => {
    const reportSettingProps = { ...reportSettings, [e.target.name]: e.target.value };

    setReportSettings({ ...reportSettingProps });
  };

  const handleReportSettingsBlur = (e) => {
    const errors = validateNewReportModalOnBlur({
      reportSettings,
      propName: e.target.name,
      modalErrors,
    });
    setErrors({ ...errors });
  };

  const handleCreateButtonClick = async () => {
    const errors = await validateNewReportModalOnCreate(reportSettings);

    if (Object.values(errors).filter((item) => item.hasError).length !== 0) {
      setErrors({ ...errors });
    } else {
      handleClose();

      history.push(
        `${REPORT_MODEL_DESIGNER}?reportKey=${reportSettings.reportName}&standaloneLayout=true&isNewReport=true`
      );
    }
  };

  return (
    <Modal
      disableBackdropClick
      open={open}
      variant="default"
      onClose={handleClose}
      title={translateString('Create New Report Model')}
      buttonProps={[
        {
          label: translateString('Cancel'),
        },
        {
          label: translateString('Create'),
          onClick: handleCreateButtonClick,
          disabled: hasModalErrors,
        },
      ]}
      className={classes.modal}
    >
      <TextField
        label={translateString('Report Model Name')}
        placeholder={translateString('Report Model Name...')}
        name="reportName"
        value={reportSettings.reportName}
        onChange={handleReportSettingsChange}
        onBlur={handleReportSettingsBlur}
        error={modalErrors.reportName.hasError}
        helperText={
          modalErrors.reportName.hasError ? translateString(modalErrors.reportName.errorText) : null
        }
        InputProps={{
          inputProps: {
            maxLength: 120,
          },
        }}
        fullWidth
        required
      />
    </Modal>
  );
};

export default NewReportModelDialog;
